import React, { Component } from 'react';
import { submit } from 'redux-form';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import { createMuiTheme } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import FlatButton from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from 'material-ui/TextField';

import 'react-table/react-table.css';

import { AccentColor } from 'helpers/AccentColorHelper';
import { isFilterInStrings } from 'helpers/StringHelper.js';
import { groupedTableData } from 'helpers/tableHelpers';
import { drawerStyle } from 'helpers/tableHelpers';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

import {
  getAmenities,
  getProperties,
  createAmenity,
  deleteAmenity,
  updateAmenityAvailability,
  amenityAvailability,
  getCalendarHolds,
} from 'actions/landlordPropertiesActions';

import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import AmenityForm from './AmenityForm';
import AmenitiesTable from './AmenitiesTable';
import MobileAmenitiesTable from './MobileAmenitiesTable';
import AmenityDetailsOverview from './AmenityDetailsOverview';

class LandlordAmenities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddAmenityDialog: false,
      showAmenityDrawer: false,
      typeFilter: '',
      selectedPropertyIds: [],
      selectedPropertiesMultiSelect: [],
      tableData: [],
      amenityDetails: null,
      amenityId: null,
      containerSize: 'calc(100% - 151px)',
      disabledAddAmenitySubmit: false,
    };
  }

  UNSAFE_componentWillMount = () => {
    this.props.getProperties({ for_multiselect: true });
    this.getAmenities();
  };

  getAmenities = async () => {
    await this.props.getAmenities();
    this.setState({ tableData: this.props.amenities });

    if (this.state.amenityId) {
      this.setState({
        amenityDetails: this.props.amenities.find(amenity => amenity.id === this.state.amenityId),
      });
    }
  };

  // Methods for the dialog
  toggleAddAmenity = () => {
    this.setState({
      showAddAmenityDialog: !this.state.showAddAmenityDialog,
    });
  };

  submitCreateAmenityForm = formData => {
    this.setState({ disabledAddAmenitySubmit: true });
    this.props.createAmenity(null, formData).then(() => {
      this.toggleAddAmenity();
      this.getAmenities();
      this.setState({ disabledAddAmenitySubmit: false });
    });
  };
  // -----------------------------

  // Methods for Filtering and Search
  getTypeFilterType = e => {
    this.setState({
      typeFilter: e.target.value,
      tableData: this.filterAmenitiesWithString(e.target.value),
    });
  };

  filterAmenitiesWithString = filterBy => {
    return this.props.amenities.filter(item =>
      isFilterInStrings(
        [
          item.property_name,
          item.name,
          item.amenity_type_humanized,
          item.description,
          item.details,
        ],
        filterBy
      )
    );
  };

  onPropertySelect = properties => {
    this.setState({
      selectedPropertyIds: properties.map(property => property.label),
      selectedPropertiesMultiSelect: properties,
      typeFilter: '',
      tableData: this.props.amenities,
    });

    this.filterByProperty(properties.map(property => property.label), this.props.amenities);
  };

  filterByProperty = (
    propertyList = this.state.selectedPropertyIds,
    filteredAmenities = this.state.tableData
  ) => {
    if (propertyList.length === 0) {
      this.setState({ tableData: filteredAmenities });
    } else {
      const selectedPropertiesSet = new Set(propertyList);

      filteredAmenities = filteredAmenities.filter(amenity =>
        selectedPropertiesSet.has(amenity.property_name)
      );

      this.setState({
        tableData: filteredAmenities,
      });
    }
  };
  // --------------------------------------

  // Methods for drawer
  openAmenityInDrawer = async amenityId => {
    await this.props.amenityAvailability(amenityId);
    if (featureEnabled('ui.amenities.calendar_holds')) {
      this.props.getCalendarHolds(amenityId);
    }

    this.setState(
      {
        amenityDetails: this.props.amenities.find(amenity => amenity.id === amenityId),
        amenityId: amenityId,
      },
      () => {
        this.toggleDrawer();
      }
    );
  };

  toggleDrawer = () => {
    this.setState({
      showAmenityDrawer: !this.state.showAmenityDrawer,
    });
  };

  updateAmenity = formData => {
    const amenityId = this.state.amenityDetails.id;
    this.props.createAmenity(amenityId, formData).then(() => {
      this.getAmenities();
      this.props.amenityAvailability(amenityId);
    });
  };

  deleteAmenity = () => {
    this.props.deleteAmenity(this.state.amenityDetails.id).then(() => {
      this.setState({ showConfirmation: false });
      this.toggleDrawer();
      this.getAmenities();
    });
  };

  updateAvailability = formData => {
    this.props.updateAmenityAvailability(this.state.amenityDetails.id, formData);
  };

  render() {
    const { isUserAdmin, canAddAmenities } = this.props;
    const userCanAdd = isUserAdmin || canAddAmenities;
    return (
      <div className="body" role="main">
        <div className="centers">
          <HeaderWithPeriod
            headerText={getTranslatedString('landlordPortal.amenities.header')}
            actionButtonLabel={
              userCanAdd && getTranslatedString('landlordPortal.amenities.addButton')
            }
            toggleDialog={this.toggleAddAmenity}
          />
          {this.renderAddAmenityDialog()}
          {this.renderMobileView()}
          {this.renderNonMobileView()}
          {this.renderAmenityDrawer()}
        </div>
      </div>
    );
  }

  renderAddAmenityDialog = () => {
    return (
      <Dialog
        disableBackdropClick
        fullScreen={this.props.fullScreen}
        open={this.state.showAddAmenityDialog}
        onClose={this.toggleAddAmenity}
        aria-labelledby="add-new-amenity"
        classes={{ paper: 'form-dialog' }}
      >
        <DialogTitle id="add-new-amenity">
          <h3 style={{ textAlign: 'center', margin: 0 }}>
            {getTranslatedString('landlordPortal.amenities.form.new_header')}
          </h3>
        </DialogTitle>
        <DialogContent>
          <AmenityForm onSubmit={this.submitCreateAmenityForm} properties={this.props.properties} />
        </DialogContent>
        <DialogActions style={{ display: 'block' }}>
          <FlatButton
            onClick={this.toggleAddAmenity}
            id="close-button"
            style={{ color: AccentColor() }}
          >
            {getTranslatedString('landlordPortal.amenities.form.cancel')}
          </FlatButton>
          <FlatButton
            variant="raised"
            onClick={() => this.props.submit('add_amenity_form')}
            disabled={this.state.disabledAddAmenitySubmit}
            id="submit-button"
            style={{
              color: 'white',
              backgroundColor: this.state.disabledSubmit ? colors.LIGHT_GRAY : AccentColor(),
            }}
          >
            {getTranslatedString('landlordPortal.amenities.form.submit')}
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  };

  renderMobileView = () => {
    return (
      <MediaQuery query="(max-device-width: 750px)">
        <div className="row" style={{ height: 'calc(100% - 33px)' }}>
          <div className="row">
            <TextField
              hintText={getTranslatedString('landlordPortal.amenities.filterByHint')}
              style={{ fontSize: '13px' }}
              value={this.state.typeFilter}
              onChange={this.getTypeFilterType}
            />
          </div>
          <MobileAmenitiesTable
            data={groupedTableData(this.state.tableData)}
            openAmenityInDrawer={this.openAmenityInDrawer}
          />
        </div>
      </MediaQuery>
    );
  };

  renderNonMobileView = () => {
    return (
      <MediaQuery query="(min-device-width: 750px)">
        <div className="row" style={{ height: this.state.containerSize }}>
          <div className="row" style={{ marginBottom: '15px' }}>
            <TextField
              hintText={getTranslatedString('landlordPortal.amenities.filterByHint')}
              style={{ fontSize: '13px' }}
              value={this.state.typeFilter}
              onChange={this.getTypeFilterType}
            />
            <div style={{ width: '250px', float: 'right' }}>{this.renderMultiselect()}</div>
          </div>
          <AmenitiesTable
            data={this.state.tableData}
            openAmenityInDrawer={this.openAmenityInDrawer}
          />
        </div>
        <div style={{ height: '10px' }} />
      </MediaQuery>
    );
  };

  renderMultiselect = () => {
    return (
      <MultiSelectExtended
        onChange={this.onPropertySelect}
        multiple
        name="property_select"
        hintText={getTranslatedString('landlordPortal.amenities.selectPropertiesHint')}
        data={this.props.properties}
        menuStyle={{ fontSize: '14px' }}
        textFieldStyle={{ padding: 0 }}
        style={{ fontSize: '14px' }}
        minHeight={'32px'}
        fullWidth
        fireOnChangeIfBlank
        withResetSelectAllButtons
        value={this.state.selectedPropertiesMultiSelect}
      />
    );
  };

  renderAmenityDrawer = () => {
    let customDrawerStyle = { ...drawerStyle };
    customDrawerStyle.overrides.MuiDrawer.paper = {
      height: '100% !important',
      backgroundColor: colors.LIGHTEST_GRAY,
    };
    return (
      <MuiThemeProvider theme={createMuiTheme(customDrawerStyle)}>
        <Drawer open={this.state.showAmenityDrawer} onClose={this.toggleDrawer} anchor="left">
          <AmenityDetailsOverview
            toggleDrawer={this.toggleDrawer}
            properties={this.props.properties}
            amenity={this.state.amenityDetails}
            updateAmenity={this.updateAmenity}
            deleteAmenity={this.deleteAmenity}
            availability={this.props.availability}
            updateAvailability={this.updateAvailability}
          />
        </Drawer>
      </MuiThemeProvider>
    );
  };
}

const ConnectedLandlordAmenities = connect(
  store => ({
    properties: store.landlordProperties.properties,
    amenities: store.landlordProperties.amenities,
    availability: store.landlordProperties.availability,
    isUserAdmin: store.userTypes.admin,
    canAddAmenities: store.userTypes.canAddAmenities,
  }),
  {
    getProperties,
    createAmenity,
    getAmenities,
    deleteAmenity,
    submit,
    updateAmenityAvailability,
    amenityAvailability,
    getCalendarHolds,
  }
)(LandlordAmenities);

export default withMobileDialog()(ConnectedLandlordAmenities);
